/**
 * GET /task-categories?relations[0]=author&relations[2]=status&relations[3]=parent
 */
export const TASK_CATEGORY_RELATIONS = {
  'relations[0]': 'author',
  'relations[2]': 'status',
  'relations[3]': 'parent',
};

export const buildTaskCategoryRelationParams = () => ({ ...TASK_CATEGORY_RELATIONS });
